// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ua46","content":"styles_content__1KF-I","row":"styles_row__PbUlZ","footer":"styles_footer__3fdQ5","phraseLength":"styles_phraseLength__3-Gxl"};